<h1 mat-dialog-title class="notification-title">
	{{ 'insights.administration.account.groups.title' | translate }}
</h1>
<mat-dialog-content [formGroup]="form">
	<div style="display: flex">
		<div class="example-container">
			<h5 class="mat-caption">
				{{ 'insights.administration.account.groups.subtitle' | translate }}
			</h5>
			<form>
				<mat-form-field appearance="outline" class="dialog" style="font-size: 14px">
					<textarea matInput rows="13" resize="false" [formControl]="groupsControl"></textarea>
				</mat-form-field>
			</form>
		</div>
	</div>
</mat-dialog-content>
<div mat-dialog-actions align="end">
	<button mat-stroked-button (click)="onNoClick()" class="button-border-color">
		{{ 'insights.administration.account.groups.cancelbtn' | translate }}
	</button>
	<button mat-flat-button color="primary" cdkFocusInitial (click)="saveAccountGroups()">
		{{ 'insights.administration.account.groups.savebtn' | translate }}
	</button>
</div>
